const API_BASE_URL =
'https://production.api.teechaa.com';
// 'https://test.api.teechaa.com'
// const API_BASE_URL = 'http://localhost:1976';
module.exports= {API_BASE_URL, 
} 
